export default __webpack_public_path__ + "static/media/mongodb.d89a6eeb.svg";